<template>
  <div class="Page Outils">
    <div class="columns">
      <div class="column is-half">
        <violet-bar>Outils</violet-bar>
        <div class="squarebox">
          Rassemblement de micro-outils : signatures e-mail, [...]
        </div>
      </div>
      <div class="column is-half"></div>
    </div>
    <violet-bar>Signatures mail</violet-bar>
    <div class="squarebox">
      <div class="columns is-multiline">
        <div class="column is-half">
          <h3>Données</h3>
          <hr />
          <h4>Personne</h4>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Prénom</label>
                <input class="input is-small" v-model="form.first_name" />
              </div>

              <div class="field">
                <label class="label">Nom</label>
                <input class="input is-small" v-model="form.last_name" />
              </div>
              <div class="field">
                <label class="label">Titre</label>
                <input class="input is-small" v-model="form.title" />
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">E-mail</label>
                <input class="input is-small" v-model="form.email" />
              </div>

              <div class="field">
                <label class="label"
                  >Mobile ? (format : 05 XX XX XX XX<br />ou +335 XX XX XX
                  XX)</label
                >
                <input class="input is-small" v-model="form.mobile" />
              </div>
            </div>
          </div>

          <hr />
          <h4>Agence</h4>
          <div class="field">
            <label class="label">URL du logo</label>
            <input class="input is-small" v-model="form.logo_url" />
          </div>

          <div class="field">
            <label class="label">Adresse</label>
            <input class="input is-small" v-model="form.address" />
          </div>

          <div class="field">
            <label class="label"
              >Téléphone fixe (format : 05 XX XX XX XX ou +335 XX XX XX
              XX)</label
            >
            <input class="input is-small" v-model="form.fixe" />
          </div>

          <hr />
          <h4>Site web</h4>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label for="" class="label">URL du site web</label>
                <input class="input is-small" v-model="form.website.url" />
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label for="" class="label">Texte du site web</label>
                <input class="input is-small" v-model="form.website.text" />
              </div>
            </div>
          </div>
          <hr />
          <h4>Réseaux sociaux</h4>
          <div
            class="field"
            v-for="(network, index) in form.networks"
            :key="index"
          >
            <div class="columns">
              <div class="column is-two-fifths">
                <div class="field">
                  <label class="label">URL ?</label
                  ><input class="input is-small" v-model="network.url" />
                </div>
              </div>
              <div class="column is-two-fifths">
                <div class="field">
                  <label class="label">Texte ?</label
                  ><input class="input is-small" v-model="network.text" />
                </div>
              </div>
              <div class="column is-one-fifth">
                <div class="field">
                  <label class="label">Montrer ?</label
                  ><input type="checkbox" v-model="network.show" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half">
          <h3>Visualisation</h3>
          <hr />
          <div class="Signature_wrap">
            <div class="Signature">
              <div class="Signature__left"><img :src="form.logo_url" /></div>
              <div class="Signature__right">
                <p>
                  {{ form.first_name }} {{ form.last_name }}<br />
                  {{ form.title }}<br />
                  {{ form.email }}<br />
                  <span v-if="form.mobile">{{ form.mobile }}</span
                  ><br /><br />
                  {{ form.address }}<br />
                  {{ form.fixe }} /
                  <a :href="form.website.url">{{ form.website.text }}</a
                  ><br />
                  <span
                    v-for="(network, index) in form.networks.filter(
                      n => n.show
                    )"
                    :key="index"
                    ><a :href="network.url">{{ network.text }}</a>
                    <span
                      v-if="
                        index < form.networks.filter(n => n.show).length - 1
                      "
                    >
                      /
                    </span></span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />
      <div class="buttons">
        <div class="button is-info" @click="submit">
          Télécharger votre signature
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VioletBar from "../Projects/VioletBar";

import { download } from "../../util/func";

export default {
  name: "Outils",
  components: { VioletBar },
  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        email: "@scalene.fr",
        title: "Architecte",
        mobile: "",
        logo_url:
          "https://scalene.fr/wp-content/themes/siblingTheme/2019-12-12_scalene_logo_bleu_300px.png",
        address: "26, rue Magné 31300 Toulouse",
        fixe: "05 31 98 22 44",
        website: { url: "https://www.scalene.fr", text: "www.scalene.fr" },
        networks: [
          {
            url: "https://instagram.com/scalene_architectes",
            text: "Instagram",
            show: true
          },
          {
            url: "https://twitter.com/scalenes",
            text: "Twitter",
            show: true
          },
          {
            url:
              "https://www.facebook.com/Scalene-architectes-280484638679126/",
            text: "Facebook",
            show: true
          }
        ]
      }
    };
  },
  methods: {
    submit() {
      download(
        `signature-${this.form.first_name}-${this.form.last_name}.htm`,
        this.makeSignature()
      );
    },
    makeSignature() {
      return `
<table style="margin:0;font-family: Arial; font-size:13.5px;;line-height:1.2;" class="sc-jDwBTQ dWtMUn"
       cellspacing="0" cellpadding="0"
>
    <tbody>
    <tr>
        <td>
            <table style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;"
                   cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                    <td style="margin:0;vertical-align: middle;" width="125"><span
                            style="margin:0;margin-right: 20px; display: block;"><img src="${
                              this.form.logo_url
                            }"
                                                                             role="presentation" width="125"/></span>
                    </td>
                    <td style="margin:0;vertical-align: top;"><span
                            style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;">
                        <span style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;">${
                          this.form.first_name
                        }</span><span>&nbsp;</span><span>${
        this.form.last_name
      }</span>
                    </span>
                        <p style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;">
                            <span style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;">${
                              this.form.title
                            }</span>
                        </p>
                        <p style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;">
                            <span style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;">${
                              this.form.email
                            }</span>
                        </p>
                        <p style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;"
                           class="sc-fMiknA bxZCMx"><span
                                style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;">${
                                  this.form.mobile
                                }&nbsp;</span>
                        </p>
                        <p style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;"
                           class="sc-fMiknA bxZCMx"><span
                                style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;">&nbsp;</span>
                        </p>
                        <p style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;">
                            <span style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;">${
                              this.form.address
                            }</span>
                        </p>
                        <p style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;">
                            <span style="margin:0;font-size: 13.5px;; font-family: Arial,sans-serif!important;color: #31287c!important;">${
                              this.form.fixe
                            } / <a
                                    style="margin:0;font-size: 13.5px;; text-decoration: underline!important; border-bottom:none!important; font-family: Arial,sans-serif!important;color: #31287c!important;"
                                    href="${this.form.website.url}">${
        this.form.website.text
      }</a></span></p>
                        <p style="margin:0;margin: 0px;" class="sc-fMiknA bxZCMx"> ${this.form.networks
                          .filter(n => n.show)
                          .map(
                            (n, i) => `<span><a
                                style="margin:0;font-size: 13.5px;; text-decoration: underline!important; border-bottom:none!important; font-family: Arial,sans-serif!important;color: #31287c!important;"
                                href="${n.url}">${n.text}</a></span>`
                          )
                          .join(" / ")} </p></td>
                </tr>
                </tbody>
            </table>
        </td>
    </tr>
    <tr>
        <td height="30"></td>
    </tr>
    </tbody>
</table>
      `;
    }
  }
};
</script>

<style lang="scss">
.Signature * {
  font-family: Arial, sans-serif !important;
  color: #312783 !important;
}

.Signature a {
  border-bottom: none !important;
  text-decoration: underline;
}

.Signature_wrap {
  padding: 1.5em;
  border: 1px solid black;
}

.Signature {
  display: flex;
  font-size: 13.5px;
  line-height: 1.2;
}

.Signature__left {
  flex: 0 0 8em * 1.2;
}

.Signature__right {
  padding-left: 15px;
}
</style>
